import { createContext, useContext, useMemo } from 'react';

import useTopScrollPosition from 'hooks/useTopScrollPosition';

const TOPBAR_MAIN_HEIGHT = {
  DESKTOP: 74,
  MOBILE: 72,
};
const TOPBAR_AD_HEIGHT = {
  DESKTOP: 40,
  MOBILE: 64,
};
const TOPBAR_BOTTOM_HEIGHT = {
  DESKTOP: 43,
  MOBILE: 72,
};

const getDesktopTopbarHeight = ({ isTopbarAdActive, isTopScrollPosition }) => {
  const topbarMainHeight = TOPBAR_MAIN_HEIGHT.DESKTOP;
  const topbarAdHeight =
    isTopbarAdActive && isTopScrollPosition ? TOPBAR_AD_HEIGHT.DESKTOP : 0;

  return topbarMainHeight + topbarAdHeight + TOPBAR_BOTTOM_HEIGHT.DESKTOP;
};

const getMobileTopbarHeight = ({
  isTopbarAdActive,
  isTopScrollPosition,
  isTopbarRedesignExperimentVariantA,
}) => {
  const topbarMainHeight = TOPBAR_MAIN_HEIGHT.MOBILE;
  const topbarAdHeight =
    isTopbarAdActive && isTopScrollPosition ? TOPBAR_AD_HEIGHT.MOBILE : 0;

  return isTopScrollPosition && !isTopbarRedesignExperimentVariantA
    ? topbarMainHeight + topbarAdHeight + TOPBAR_BOTTOM_HEIGHT.MOBILE
    : topbarMainHeight + topbarAdHeight;
};

const TopbarContext = createContext({
  isTopbarActive: true,
  topbarDesktop: null,
  topbarMobile: null,
});

const TopbarProvider = ({
  children,
  isTopbarAdActive,
  isTopbarActive = true,
}) => {
  const [isTopScrollPosition] = useTopScrollPosition();

  const value = useMemo(() => {
    const topbarDesktop = {
      constants: {
        adHeight: TOPBAR_AD_HEIGHT.DESKTOP,
        topbarBottomHeight: TOPBAR_BOTTOM_HEIGHT.DESKTOP,
        topbarMainHeight: TOPBAR_MAIN_HEIGHT.DESKTOP,
      },
      isTopbarActive,
      height: getDesktopTopbarHeight({ isTopbarAdActive, isTopScrollPosition }),
    };

    const topbarMobile = {
      height: getMobileTopbarHeight({
        isTopbarAdActive,
        isTopScrollPosition,
      }),
    };

    return {
      isTopbarActive,
      topbarDesktop,
      topbarMobile,
    };
  }, [isTopbarActive, isTopbarAdActive, isTopScrollPosition]);

  return (
    <TopbarContext.Provider value={value}>{children}</TopbarContext.Provider>
  );
};

export const useTopbar = () => useContext(TopbarContext);

export default TopbarProvider;
